import React, { useState, useRef, useEffect } from 'react'
import Header from 'components/headers/bulletins'
import { Link } from 'react-router-dom'
import { FaPlay, FaApple, FaAndroid } from 'react-icons/fa'

const SignDetails = () => {
    const [showPopup, setShowPopup] = useState(false)
    const popupRef = useRef<HTMLDivElement>(null)

    const handleTogglePopup = () => {
        setShowPopup((prev) => !prev)
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (
            popupRef.current &&
            !popupRef.current.contains(event.target as Node)
        ) {
            setShowPopup(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div className="flex flex-col items-center w-full relative">
            <Header title="امضای دیجیتال" />
            <div className="flex flex-col items-center m-3 space-y-3 w-full p-4">
                <p className="text-justify leading-7 p-3 shadow-sm border bg-green-2 rounded w-full">
                    <span className="block font-bold">مراحل ۲ و ۴:</span>
                    در صورتی که گواهی امضا را از امضامی دریافت نکرده اید٬ ابتدا
                    اقدام به دریافت گواهی امضا کرده و بعد از تکمیل فرم پیش نویس
                    سفته٬ به صفحه ارسال امضا به امضامی رفته و سفته خود را برای
                    امضامی ارسال کنید
                </p>
                <div className="flex gap-1 w-full">
                    <Link
                        to="https://cafebazaar.ir/app/com.emzame.app"
                        target="_blank"
                        className="w-full"
                    >
                        <div className="flex justify-around items-center border bg-green-1 text-white text-center mt-3 rounded-xl p-2 ">
                            <small className="text-center">
                                دریافت امضامی
                                <span className="block">کافه بازار</span>
                            </small>
                            <i className="text-2xl">
                                <FaAndroid />
                            </i>
                        </div>
                    </Link>
                    <Link
                        to="https://sibapp.com/applications/Emzame"
                        target="_blank"
                        className="w-full"
                    >
                        <div className="flex justify-around items-center border bg-green-1 text-white text-center mt-3 rounded-xl p-2 ">
                            <small>
                                دریافت امضامی
                                <span className="block">سیب اپ</span>
                            </small>
                            <i className="text-2xl">
                                <FaApple />
                            </i>
                        </div>
                    </Link>
                </div>
                <div className="w-full mt-7">
                    <div
                        className="grid grid-cols-4 items-center text-green-1 border border-green-1 rounded-md w-full p-3 cursor-pointer"
                        onClick={handleTogglePopup}
                    >
                        <FaPlay className="text-2xl font-bold col-start-1 mr-5" />
                        <span className="col-start-2 col-end-5 text-sm font-bold">
                            لینک آموزش گواهی امضا در امضامی
                        </span>
                    </div>
                </div>
                <p className="text-justify leading-7 p-3 mt-5 shadow-sm border bg-green-2 rounded w-full">
                    <span className="block font-bold"> مرحله ۳:</span>
                    قبل از ارسال و ثبت سفته دیجیتال در امضامی٬ اطمینان حاصل کنید
                    که در امضامی گواهی امضا صادر شده باشد
                </p>
                <Link to="/promissory/promissory-sign" className="w-full">
                    <div className="border bg-green-1 text-white text-center mt-3 rounded-xl p-4">
                        ارسال سفته به امضامی
                    </div>
                </Link>
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 p-4">
                    <div
                        ref={popupRef}
                        className="bg-white p-2 rounded-md shadow-lg relative w-full max-w-3xl"
                    >
                        <button
                            className="absolute top-2 right-2 text-2xl font-bold"
                            onClick={handleTogglePopup}
                        >
                            &times;
                        </button>
                        <div className="relative w-full pb-[56.25%] h-0">
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-md"
                                src="https://www.aparat.com/video/video/embed/videohash/q5006c4/vt/frame"
                                allowFullScreen
                                title="Video Tutorial"
                                style={{ border: 'none' }}
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SignDetails
